export default __webpack_public_path__ + "static/media/bowsersfury3.87d70e85.mov";